import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface DealerItem {
  id: any;
  nome: string;
  selecionado: boolean;
  toTexto(): string;
  toDescricao(): string;
  hint?: string; // Propriedade opcional para hint personalizado
}

@Component({
  selector: 'app-filtro-dealers',
  templateUrl: './filtro-dealers.component.html',
  styleUrls: ['./filtro-dealers.component.css']
})
export class FiltroDealersComponent implements OnInit {

  @Input() visible: boolean = false;
  @Input() dealers: DealerItem[] = [];
  @Input() headerTitle: string = 'relatorioVeiculos.controlePedidos.selecioneDealers';
  @Input() filterPlaceholder: string = 'relatorioVeiculos.controlePedidos.filtrarDealers';
  @Input() modalWidth: string = '800px';
  @Input() showHints: boolean = false; // Propriedade para controlar se hints devem ser exibidos

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() dealerSelected = new EventEmitter<DealerItem>();

  filtroTexto: string = '';

  constructor() { }

  ngOnInit(): void {
  }

  get displayModal(): boolean {
    return this.visible;
  }

  set displayModal(value: boolean) {
    this.visible = value;
    this.visibleChange.emit(this.visible);
    
    // Limpar filtro quando modal é aberto/fechado
    if (value) {
      this.filtroTexto = '';
    } else {
      // Forçar fechamento de todos os tooltips quando modal fechar
      this.fecharTodosTooltips();
    }
  }

  get dealersNaoSelecionados(): DealerItem[] {
    return this.dealers.filter(dealer => !dealer.selecionado);
  }

  get dealersFiltrados(): DealerItem[] {
    if (!this.filtroTexto || this.filtroTexto.trim() === '') {
      return this.dealersNaoSelecionados;
    }
    
    const textoFiltro = this.filtroTexto.toLowerCase();
    return this.dealersNaoSelecionados.filter(dealer => 
      dealer.nome.toLowerCase().includes(textoFiltro)
    );
  }

  onSelecionarDealer(dealer: DealerItem): void {
    this.dealerSelected.emit(dealer);
  }

  onFecharModal(): void {
    this.displayModal = false;
  }

  getHintText(dealer: DealerItem): string | null {
    // Prioridade: hint personalizado > descricao > toDescricao() > null
    const descricao = (dealer as any).descricao;
    return dealer.hint || (descricao != null && descricao !== '' ? descricao : null) || (dealer.toDescricao?.() ?? null) || null;
  }

  private fecharTodosTooltips(): void {
    // Remove todos os tooltips do PrimeNG do DOM
    setTimeout(() => {
      const tooltips = document.querySelectorAll('.p-tooltip, .ui-tooltip');
      tooltips.forEach(tooltip => {
        if (tooltip && tooltip.parentNode) {
          tooltip.parentNode.removeChild(tooltip);
        }
      });
    }, 0);
  }
}
